import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";

const Jira: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <h1>
        <a href='https://4r-soluciones.atlassian.net/jira/projects?selectedProjectType=software'>
          Jira
        </a>
      </h1>
      <p className='text-justify'>
        Crombie usa el paquete de herramientas de Atlassian para trabajar. Esto
        incluye Jira, que es una{" "}
        <i>
          herramienta en linea para la administración de tareas de un proyecto,
          el seguimiento de errores e incidencias.
        </i>
        . Que en español significa que ahí vas a encontrar todas las tareas que
        componen un proyecto, permitiendo saber cuanto tiempo se cree se va a
        tomar, cuanto tiempo se tomó efectivamente, y en que cosa se tomo cada
        tiempo.
      </p>
      <h2>Me da pachorra trackear en las tarjetas</h2>
      <p className='text-justify'>
        No seas como Giancarelli y trackea. Si no trackeas no vamos a poder
        saber en que estamos fallando.{" "}
        <strong>No es una medida de desempeño personal</strong> es una forma de
        obtener información continua que nos permita tomar buenas decisiones
        operativas. Si nuestra medida es incorrecta, tomaremos malas decisiones.
      </p>
      <h2>No me deja mover las tarjetas</h2>
      <p className='text-justify'>
        Jira esta configurado para que las tarjetas en todo momento tengan que
        cumplir con una serie de reglas. Eso implica, por ejemplo, que si querés
        mover una tarjeta a un estado que tiene restricciones (capaz tiene que
        tener tiempo cargado) jira va a rechazar el movimiento de la tarjeta.
      </p>
    </Container>
  );
};

export default new Content({
  Component: Jira,
  title: "Jira",
  route: "jira",
  tags: [
    "jira",
    "project",
    "manager",
    "management",
    "track",
    "version control",
    "bitbucket",
    "repository",
    "kanbam"
  ]
});
